module.exports = __webpack_public_path__ + "qa.svg?947efd9ba8daabcd84e99bd9ea9e1bfb";